module.exports = __webpack_public_path__ + "static/media/menuBell.e897d559.svg";